module.exports = __webpack_public_path__ + "sg-logo.5c4a6db3.png";